import { Route } from 'vue-router';
import { mobileUtil } from '@panda/tool';

const queryGeek = () => (mobileUtil.isGeekApp() ? { needlogin: true, portrait: true } : {});
const QUERY = queryGeek();
const PAGE_TITLE_PRIVACY = '个人信息收集与使用清单';

export default [
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/privacy/Index.vue'),
    redirect: { name: 'Privacy.Index' },
    meta: {
      title: PAGE_TITLE_PRIVACY,
    },
    children: [
      {
        path: '/privacy/list',
        name: 'Privacy.List',
        component: () => import(/* webpackChunkName: "privacy.list" */ '../views/privacy/PrivacyList.vue'),
        meta: {
          title: PAGE_TITLE_PRIVACY,
          needLogin: true,
          query: QUERY,
        },
      },
      {
        path: '/privacy/detail',
        name: 'Privacy.Detail',
        component: () => import(/* webpackChunkName: "privacy.detail" */ '../views/privacy/PrivacyDetail.vue'),
        meta: {
          title: PAGE_TITLE_PRIVACY,
          query: QUERY,
        },
        props: (route: Route) => ({
          parentId: (route.query || {}).parentId || '',
        }),
      },
      {
        path: '/privacy/content',
        name: 'Privacy.Content',
        component: () => import(/* webpackChunkName: "privacy.content" */ '../views/privacy/PrivacyContent.vue'),
        meta: {
          title: PAGE_TITLE_PRIVACY,
          query: QUERY,
        },
        props: (route: Route) => ({
          cataId: (route.query || {}).cataId || '',
        }),
      },
    ],
  },
];
